import { ChevronDown } from 'lucide-react'
import { useState } from 'react'
import { useStrata } from '../../data/StrataProvider'
import type { SetRecord, WorkoutSession } from '../../domain/types'
import { formatMass, formatTrainingVolume, type UnitSystem } from '../../domain/units'

export function HistoryPage() {
  const { state } = useStrata()
  const [expanded, setExpanded] = useState<string>()
  const sessions = [...state.sessions].sort((a, b) => b.startedAt.localeCompare(a.startedAt))

  return (
    <div className="page history-page">
      <header className="page-header history-header"><span className="eyebrow">REGISTRO DE WORKOUTS</span><h1>Sesiones</h1><p>Aquí se guarda cada entrenamiento: ejercicios, series, peso, repeticiones, duración, volumen y récords.</p></header>
      {!sessions.length && <div className="history-empty"><strong>Aún no hay sesiones.</strong><p>En cuanto completes la primera serie de un workout aparecerá aquí y se guardará en tu cuenta.</p></div>}
      <div className="timeline">
        {sessions.map((session) => (
          <article className={expanded === session.id ? 'timeline-row expanded' : 'timeline-row'} key={session.id}>
            <div className="timeline-axis"><i /><b /></div>
            <div className="timeline-content">
              <button className="timeline-summary" onClick={() => setExpanded((value) => value === session.id ? undefined : session.id)}>
                <span><small>{dayLabel(session.startedAt)} {session.status === 'in_progress' ? '· EN CURSO' : ''}</small><strong>{session.name}</strong><em>{session.sets.length} series · {duration(session)} · {formatTrainingVolume(session.volume, state.preferences.unit)} · {session.prCount} PR</em></span>
                <ChevronDown size={17} />
              </button>
              {expanded === session.id && <SessionSets session={session} unit={state.preferences.unit} />}
            </div>
          </article>
        ))}
      </div>
    </div>
  )
}

function SessionSets({ session, unit }: { session: WorkoutSession; unit: UnitSystem }) {
  const groups = Object.values(session.sets.reduce<Record<string, SetRecord[]>>((result, set) => {
    result[set.exerciseId] = [...(result[set.exerciseId] ?? []), set]
    return result
  }, {})).sort((a, b) => a[0].position - b[0].position)
  return <div className="session-sets">{groups.map((sets) => <div key={sets[0].exerciseId}><strong>{sets[0].exerciseName}</strong><span>{sets.map((set) => setSummary(set, unit)).join('  ')}</span></div>)}</div>
}

function setSummary(set: SetRecord, unit: UnitSystem) {
  if (set.durationSeconds) return `${Math.round(set.durationSeconds)}s`
  return set.weight ? `${formatMass(set.weight, unit)}×${set.reps ?? 0}` : `${set.reps ?? 0}`
}
function dayLabel(value: string) { return new Intl.DateTimeFormat('es-MX', { weekday: 'short', day: 'numeric' }).format(new Date(value)).toUpperCase() }
function duration(session: WorkoutSession) { const min = Math.round((new Date(session.endedAt).getTime() - new Date(session.startedAt).getTime()) / 60_000); return min >= 60 ? `${Math.floor(min / 60)} h ${min % 60}` : `${min} min` }
